import React from 'react';
import {View, Text} from '@react-pdf/renderer';
import styles from '../styles';
import {ControlItem, ControlName} from './ControlsComponents';

const FifthSection = props => {
  return (
    <View style={styles.row}>
      <View style={[styles.width5, styles.sectionHeader, styles.center]}>
        <Text style={[styles.text10, styles.rotated, {width: '250%'}]}>
          ÇDO VIT
        </Text>
      </View>
      <View style={[styles.flex1, styles.borderLeft]}>
        <View style={[styles.row]}>
          <ControlName text="Boshti kryesor ngasës" />
          <View style={styles.flex1}>
            <View style={[styles.row]}>
              <ControlItem
                text="Kontakti nëse boshti ngasës i parmakut ka funksionim normal"
                style={[styles.flex1]}
                selected={props.check54}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Vajosja boshtin e njësisë ngasëse"
                noCheck
                style={[styles.flex1]}
              />
              <ControlItem
                text="Majtas"
                selected={props.check55}
                style={[styles.center, {width: '11.6%'}]}
              />
              <ControlItem
                text="Djathtas"
                selected={props.check56}
                style={[styles.center, {width: '12.8%'}]}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Nëse kërkohet rregullimi (kalibrimi) a është bërë?"
                style={[styles.flex1]}
                selected={props.check57}
              />
            </View>
          </View>
        </View>
        <View style={[styles.row]}>
          <ControlName text={`Boshti ngasës i handrail (parmakut të\ngomës)`} />
          <View style={styles.flex1}>
            <View style={[styles.row]}>
              <ControlItem
                text="Kontrollo nëse boshti ngasës i parmakut ka funksionim normal"
                style={[styles.flex1]}
                selected={props.check58}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Vajosja boshtin"
                noCheck
                style={[styles.flex1]}
              />
              <ControlItem
                text="Majtas"
                selected={props.check59}
                style={[styles.center, {width: '11.6%'}]}
              />
              <ControlItem
                text="Djathtas"
                selected={props.check60}
                style={[styles.center, {width: '12.8%'}]}
              />
            </View>
            <View style={styles.row}>
              <ControlItem
                text="Nëse kërkohet rregullimi (kalibrimi) a është bërë?"
                style={[styles.flex1]}
                selected={props.check61}
              />
            </View>
          </View>
        </View>
      </View>
    </View>
  );
};

export default FifthSection;
